import { render, staticRenderFns } from "./PermissionsSelect.vue?vue&type=template&id=c51d8276&scoped=true"
import script from "./PermissionsSelect.vue?vue&type=script&lang=js"
export * from "./PermissionsSelect.vue?vue&type=script&lang=js"
import style0 from "./PermissionsSelect.vue?vue&type=style&index=0&id=c51d8276&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c51d8276",
  null
  
)

export default component.exports